import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { viewLoadLandingPage } from '../../action/landingpage.action';
import { Meta, Title } from '@angular/platform-browser';
import { JsonLdService } from 'ngx-seo';
import { DynamicLandingpageComponent } from '../../landingpages/dynamic-landingpage/dynamic-landingpage.component';
import { MatDialog } from '@angular/material/dialog';
@Component({
  selector: 'app-template-one',
  templateUrl: './template-one.component.html',
  styleUrl: './template-one.component.scss'
})
export class TemplateOneComponent implements OnInit{
  activeIndex: number | null = null;
  dynamicStatus:boolean=true;
  gifLoader:boolean;
  pageData: any;
//  pageData = {
//     id: 8,
//     banner_header: 'Upgrade Your Business with Our Cutting-Edge POS Solutions!',
//     banner_sub_content: 'Experience the future of transactions! Schedule a demo today and witness how  our POS solution can revolutionize your business.',
//     cta_button_one: true,
//     cta_button_two: true,
//     cta_button_name_one: 'Start Free Trial',
//     cta_button_link_one: 'https://medeil.com/en/medeil-cloud-pos',
//     cta_button_name_two: 'Purchase Now',
//     cta_button_link_two: 'https://medeil.com/en/medeil-cloud-pos',
//     main_color: '#000000',
//     sub_color: '#007bff',
//     keyword: null,
//     seo_keyword: null,
//     seo_title: null,
//     seo_description: null,
//     feature_heading: "Delightfully Simple And Deceptively Our Point of Sale System",
//     faq_heading: "Here Some Questions Answer",
//     status: 0,
//     template_name: 'Template_1',
//     seo_url_name: 'landingpage-pharmacy-software',
//     feature: [
//       {
//         featureid: 3,
//         feature_sub_heading: 'Suitable For All Types of Businesses',
//         feature_description: 'Seamlessly manage your business operations with ease and efficiency.',
//       },
//       {
//         featureid: 4,
//         feature_sub_heading: 'Cost Effective & Affordable Pricing',
//         feature_description: 'Get premium features at a price that suits your budget.',
//       },
//       {
//         featureid: 5,
//         feature_sub_heading: 'Easy to Setup & No IT Knowledge Needed',
//         feature_description: 'Set up your POS system quickly without technical expertise.',
//       },
//       {
//         featureid: 6,
//         feature_sub_heading: 'Modern & Attractive User Dashboard',
//         feature_description: 'A sleek and intuitive interface designed for efficiency.',
//       },
//     ],
//     faq: [
//       { faqid: 1, quetion: 'How Does a POS System Benefit My Business?', answer: 'A POS system streamlines operations, tracks sales, and improves customer experience.' },
//       { faqid: 2, quetion: 'Can I Integrate the POS System with My Online Store?', answer: 'Yes, most modern POS systems can integrate with e-commerce platforms for seamless inventory management.' },
//       { faqid: 3, quetion: 'Do I Need Special Training to Use a POS System?', answer: 'No, most POS systems are user-friendly and come with training resources.' },
//       { faqid: 4, quetion: 'What Kind of Sales Analytics Does a POS System Provide?', answer: 'A POS system provides reports on sales, inventory, customer trends, and more.' },
//       { faqid: 5, quetion: 'How Can I Choose the Right POS System for My Business?', answer: 'Consider factors like features, budget, and compatibility with your existing tools before choosing a POS system.' }
//     ]
//   };
  constructor(private dialog:MatDialog,private route: ActivatedRoute, private router: Router,private store:Store,private meta: Meta, private titleService: Title, private jsonLdService: JsonLdService) {
      this.store.dispatch(viewLoadLandingPage());
  }

  ngOnInit() {
    const title = this.route.snapshot.paramMap.get('seoUrl');
    if(title ==null || title ==undefined || title ==""){
      this.dynamicStatus=false;
      this.pageData = {
        id: 8,
        banner_header: 'Upgrade Your Business with Our Cutting-Edge POS Solutions!',
        banner_sub_content: 'Experience the future of transactions! Schedule a demo today and witness how  our POS solution can revolutionize your business.',
        cta_button_one: true,
        cta_button_two: true,
        cta_button_name_one: 'Start Free Trial',
        cta_button_link_one: 'https://www.medeil.com/en/medeil-cloud-pos',
        cta_button_name_two: 'Purchase Now',
        cta_button_link_two: 'https://www.medeil.com/en/medeil-cloud-pos',
        bottom_cta_button_link: 'https://www.medeil.com/en/medeil-cloud-pos',
        bottom_cta_button_name: 'Purchase Now',
        bottom_cta_description: 'Experience the best solutions tailored for you. Join us today!',
        main_color: '#000000',
        sub_color: '#007bff',
        keyword: null,
        seo_keyword: null,
        seo_title: null,
        seo_description: null,
        feature_heading: "Delightfully Simple And Deceptively Our Point of Sale System",
        faq_heading: "Here Some Questions Answer",
        status: 0,
        template_name: 'Template_1',
        seo_url_name: 'landingpage-pharmacy-software',
        feature: [
          {
            featureid: 3,
            feature_sub_heading: 'Suitable For All Types of Businesses',
            feature_description: 'Seamlessly manage your business operations with ease and efficiency.',
          },
          {
            featureid: 4,
            feature_sub_heading: 'Cost Effective & Affordable Pricing',
            feature_description: 'Get premium features at a price that suits your budget.',
          },
          {
            featureid: 5,
            feature_sub_heading: 'Easy to Setup & No IT Knowledge Needed',
            feature_description: 'Set up your POS system quickly without technical expertise.',
          },
          {
            featureid: 6,
            feature_sub_heading: 'Modern & Attractive User Dashboard',
            feature_description: 'A sleek and intuitive interface designed for efficiency.',
          },
        ],
        faq: [
          { faqid: 1, quetion: 'How Does a POS System Benefit My Business?', answer: 'A POS system streamlines operations, tracks sales, and improves customer experience.' },
          { faqid: 2, quetion: 'Can I Integrate the POS System with My Online Store?', answer: 'Yes, most modern POS systems can integrate with e-commerce platforms for seamless inventory management.' },
          { faqid: 3, quetion: 'Do I Need Special Training to Use a POS System?', answer: 'No, most POS systems are user-friendly and come with training resources.' },
          { faqid: 4, quetion: 'What Kind of Sales Analytics Does a POS System Provide?', answer: 'A POS system provides reports on sales, inventory, customer trends, and more.' },
          { faqid: 5, quetion: 'How Can I Choose the Right POS System for My Business?', answer: 'Consider factors like features, budget, and compatibility with your existing tools before choosing a POS system.' }
        ]
      };
      this.titleService.setTitle(this.pageData.seo_title);
      this.meta.updateTag({ name: 'keywords', content: this.pageData.seo_keyword });
      this.meta.updateTag({ name: 'description', content: this.pageData.seo_description });
    }
    else {
      this.gifLoader=true;
      this.store.select((state:any)=>state.landingpage).subscribe((data:any)=>{
        if(data){
          this.gifLoader=false;
          this.pageData=data.landingpage.find(lp=>lp.seo_url_name==title)
          console.log('Received Page Data:', this.pageData);
          this.titleService.setTitle(this.pageData.seo_title);
          // Update meta tags
          this.meta.updateTag({ name: 'keywords', content: this.pageData.seo_keyword });
          this.meta.updateTag({ name: 'description', content: this.pageData.seo_description });
        }
      })
    }
  }

  toggleFAQ(index: number): void {
    this.activeIndex = this.activeIndex === index ? null : index;
  }
  addLandingPageSchema() {
    if (!this.pageData) {
      return; // Ensure pageData exists before using it
    }

    const schemaData = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": this.pageData.seo_title || "Default Landing Page Title",
      "description": this.pageData.seo_description || "Default Landing Page Description",
      "url": "https://www.medeil.com",
      "image": this.pageData.image || "https://www.medeil.com/en/assets/img/logo/Medeilicon1.png",
      "keywords": this.pageData.seo_keyword || "default, keywords",
      "author": {
        "@type": "Organization",
        "name": "Vanuston Intelligence Private Limited",
        "url": "https://vanuston.com/"
      }
    };
    this.jsonLdService.setData(schemaData);
  }
  openLandingpage(leadsource:any){
    const dialogRef=this.dialog.open(DynamicLandingpageComponent,{
           width:'550px',
           data:leadsource

         })
         dialogRef.afterClosed().subscribe((data)=>{
           if(data){
             console.log(data);
           }
         })
  }
}
